module.exports = __webpack_public_path__ + "img/icon_edit.71a814a7.svg";